import { cn as e } from "../shared/utils.js";
import { Badge as t } from "../badge/badge.js";
import { TooltipTextOverflow as n } from "../tooltip/tooltip-text-overflow.js";
import { buttonVariants as r } from "../button/primitive/button.js";
import { useTranslation as i } from "../i18n/hooks.js";
import { breakpointQueries as a } from "../shared/breakpoints.js";
import { useMediaQuery as o } from "../shared/hooks/use-media-query.js";
import { Menu as s } from "../menu/index.js";
import { Skeleton as c } from "../skeleton/skeleton.js";
import { useRender as l } from "@base-ui/react/use-render";
import { ChevronDownIcon as u, ChevronLeftIcon as d, ChevronRightIcon as f } from "@systemeio/icons";
import { forwardRef as p } from "react";
import { jsx as m, jsxs as h } from "react/jsx-runtime";
import { cva as g } from "class-variance-authority";
//#region src/breadcrumbs/breadcrumbs.tsx
var _ = 4, v = 2, y = g("text-base inline-flex min-w-0 items-center gap-1", {
	defaultVariants: { state: "default" },
	variants: { state: {
		default: "text-text-secondary [&_svg]:text-icon-secondary",
		active: "text-text-link [&_svg]:text-text-link"
	} }
}), b = g("transition-base", {
	defaultVariants: { state: "default" },
	variants: { state: {
		default: "hover:text-text-primary hover:[&_svg]:text-icon-primary",
		active: "hover:text-text-link"
	} }
}), x = p(({ "aria-label": t = "Breadcrumb", className: n, ...r }, i) => /* @__PURE__ */ m("nav", {
	ref: i,
	"aria-label": t,
	className: e("min-w-0", n),
	...r
})), S = p(({ className: t, ...n }, r) => /* @__PURE__ */ m("ol", {
	ref: r,
	className: e("-m-1 flex min-w-0 flex-nowrap items-center gap-2 overflow-hidden p-1 whitespace-nowrap", t),
	...n
})), C = p(({ className: t, ...n }, r) => /* @__PURE__ */ m("li", {
	ref: r,
	className: e("flex min-w-0 shrink items-center gap-1.5", t),
	...n
})), w = p(({ className: t, render: n, state: r, ...i }, a) => {
	let o = {
		className: e(y({ state: r }), b({ state: r }), "outline-none focus-visible:focus-ring-primary", t),
		"data-slot": "breadcrumb-link",
		"data-testid": "breadcrumb-link",
		...i
	};
	return l({
		defaultTagName: "a",
		props: o,
		ref: a,
		render: n
	});
}), T = p(({ className: t, render: n, ...r }, i) => {
	let a = {
		className: e("outline-none", t),
		"data-slot": "breadcrumb-menu-link",
		"data-testid": "breadcrumb-menu-link",
		...r
	};
	return l({
		defaultTagName: "a",
		props: a,
		ref: i,
		render: n
	});
}), E = p(({ className: t, state: n, ...r }, i) => /* @__PURE__ */ m("span", {
	ref: i,
	className: e("text-text-secondary [&_svg]:text-icon-secondary inline-flex min-w-0 items-center gap-1", t),
	...r
})), D = p(({ className: t, open: n, ...r }, i) => /* @__PURE__ */ m("span", {
	ref: i,
	className: e("text-text-secondary hover:bg-bg-secondary transition-base flex h-5 min-w-6 items-center justify-center rounded-sm px-1.5 text-base leading-none", n && "bg-bg-secondary text-text-link", t),
	...r,
	children: "..."
})), O = p(({ className: t, state: n, ...r }, i) => /* @__PURE__ */ m("span", {
	ref: i,
	className: e(y({
		className: t,
		state: n
	})),
	...r
}));
function k({ icon: t, className: n, ...r }) {
	return /* @__PURE__ */ m(t, {
		className: e("transition-base size-4 shrink-0", n),
		...r
	});
}
var A = p(({ children: t = /* @__PURE__ */ m(f, { className: "size-4" }), className: n, ...r }, i) => /* @__PURE__ */ m("span", {
	ref: i,
	"aria-hidden": "true",
	className: e("text-icon-secondary flex shrink-0 items-center", n),
	...r,
	children: t
}));
function j({ item: t, isCurrent: r }) {
	if (t.loading) {
		let { className: n, ...r } = t.skeletonProps ?? {};
		return /* @__PURE__ */ m(c, {
			className: e("h-5 w-24", n),
			...r
		});
	}
	return r || !t.href ? /* @__PURE__ */ h(V.Text, {
		...t.textProps,
		"aria-current": r ? "page" : void 0,
		state: r ? "active" : "default",
		children: [t.icon && /* @__PURE__ */ m(V.Icon, {
			icon: t.icon,
			...t.iconProps
		}), /* @__PURE__ */ m(n, { children: t.label })]
	}) : /* @__PURE__ */ h(V.Link, {
		href: t.href,
		...t.linkProps,
		state: "default",
		children: [t.icon && /* @__PURE__ */ m(V.Icon, {
			icon: t.icon,
			...t.iconProps
		}), /* @__PURE__ */ m(n, { children: t.label })]
	});
}
function M(e) {
	let t = e.findIndex((e) => e.current);
	return t >= 0 ? t : e.length - 1;
}
function N(r, i) {
	return r.loading ? /* @__PURE__ */ m(c, {
		...r.menuSkeletonProps,
		className: e("h-4 w-full", r.menuSkeletonProps?.className)
	}) : /* @__PURE__ */ h("span", {
		className: "flex w-full min-w-0 items-center gap-2",
		children: [/* @__PURE__ */ h(V.MenuText, {
			className: "text-text-primary [&_svg]:text-icon-primary min-w-0 flex-1",
			children: [r.icon && /* @__PURE__ */ m(V.Icon, {
				icon: r.icon,
				...r.iconProps
			}), /* @__PURE__ */ m(n, { children: r.label })]
		}), i?.showCurrentBadge ? /* @__PURE__ */ m(t, {
			color: "outlinedGray",
			shape: "rounded",
			size: "md",
			children: i.currentBadgeLabel
		}) : null]
	});
}
function P(e, t, n) {
	return e.map((e, r) => {
		let i = e.id ?? `path-${r}`, a = r === t, o = e.loading;
		return a ? {
			id: i,
			label: N(e, {
				showCurrentBadge: !0,
				currentBadgeLabel: n
			}),
			className: "bg-palette-blue-bg",
			closeOnSelect: !1,
			disabled: o || void 0
		} : e.href && !o ? {
			id: i,
			type: "link",
			label: N(e),
			render: /* @__PURE__ */ m(V.MenuLink, {
				href: e.href,
				...e.linkProps
			})
		} : {
			id: i,
			disabled: !0,
			label: N(e),
			closeOnSelect: !1
		};
	});
}
function F({ items: t, menuProps: r }) {
	let { triggerProps: i, ...a } = r ?? {};
	return /* @__PURE__ */ m(s, {
		align: "start",
		...a,
		triggerProps: {
			"aria-label": "Show hidden breadcrumbs",
			...i
		},
		trigger: ({ open: e }) => /* @__PURE__ */ m(V.MenuTrigger, {
			"aria-hidden": "true",
			open: e
		}),
		items: t.map((t, r) => {
			let i = t.loading, a = t.id ?? `collapsed-${r}`, o = i ? /* @__PURE__ */ m(c, {
				...t.menuSkeletonProps,
				className: e("h-4 w-full", t.menuSkeletonProps?.className)
			}) : /* @__PURE__ */ h(V.MenuText, { children: [t.icon && /* @__PURE__ */ m(V.Icon, {
				icon: t.icon,
				...t.iconProps
			}), /* @__PURE__ */ m(n, { children: t.label })] });
			return t.href && !i ? {
				id: a,
				type: "link",
				label: o,
				render: /* @__PURE__ */ m(V.MenuLink, {
					href: t.href,
					...t.linkProps
				})
			} : {
				id: a,
				disabled: i || void 0,
				label: o
			};
		})
	});
}
function I({ item: t }) {
	let { render: n, className: i, ...a } = t.linkProps ?? {};
	return l({
		defaultTagName: "a",
		props: {
			...a,
			href: t.href,
			"aria-label": "Go to previous page",
			"data-slot": "breadcrumbs-back",
			"data-testid": "breadcrumbs-back",
			className: e(r({
				variant: "ghost-gray",
				size: "icon-sm"
			}), "shrink-0", i),
			children: /* @__PURE__ */ m(d, { className: "size-4" })
		},
		render: n
	});
}
function L({ open: t, item: r }) {
	return /* @__PURE__ */ h("span", {
		"data-slot": "breadcrumbs-mobile-current",
		"data-testid": "breadcrumbs-mobile-current",
		className: "text-text-link inline-flex max-w-full min-w-0 items-center gap-1 text-base",
		"aria-current": "page",
		children: [r.loading ? /* @__PURE__ */ m(c, {
			...r.skeletonProps,
			className: e("h-5 w-24", r.skeletonProps?.className)
		}) : /* @__PURE__ */ m(n, {
			className: "text-text-link",
			children: r.label
		}), /* @__PURE__ */ m(u, {
			className: e("text-text-link transition-base size-4 shrink-0 transition-transform", t && "rotate-180"),
			"aria-hidden": "true"
		})]
	});
}
function R({ items: t, menuProps: n, currentBadgeLabel: r, navigationPathTitle: i, ...a }) {
	let o = M(t), c = t[o], l = o > 0 ? t[o - 1] : void 0, u = !!(l?.href && !l.loading), { triggerProps: d, drawerTitle: f = i, ...p } = n ?? {};
	return c ? /* @__PURE__ */ m(V.Root, {
		...a,
		children: /* @__PURE__ */ h("div", {
			className: "flex min-w-0 items-center gap-1",
			children: [u && l ? /* @__PURE__ */ m(I, { item: l }) : null, /* @__PURE__ */ m(s, {
				align: "start",
				drawerTitle: f,
				...p,
				triggerProps: {
					...d,
					className: e("min-w-0 max-w-full", d?.className)
				},
				trigger: ({ open: e }) => /* @__PURE__ */ m(L, {
					open: e,
					item: c
				}),
				items: P(t, o, r)
			})]
		})
	}) : /* @__PURE__ */ m(V.Root, { ...a });
}
function z({ items: e, listProps: t, menuProps: n, visibleEdgeItemsCount: r = v, visibleItemsCount: i = _, ...a }) {
	let o = Math.min(r, Math.floor(i / 2)), s = e.length > i, c = s ? e.slice(0, o) : e, l = s ? e.slice(o, o > 0 ? -o : void 0) : [], u = s && o > 0 ? e.slice(-o) : [];
	return /* @__PURE__ */ m(V.Root, {
		...a,
		children: /* @__PURE__ */ h(V.List, {
			...t,
			children: [
				c.map((t, n) => {
					let r = n === e.length - 1, i = t.current ?? r;
					return /* @__PURE__ */ h(V.Item, {
						...t.itemProps,
						children: [n > 0 && /* @__PURE__ */ m(V.Separator, { ...t.separatorProps }), /* @__PURE__ */ m(j, {
							item: t,
							isCurrent: i
						})]
					}, t.id ?? n);
				}),
				s && /* @__PURE__ */ h(V.Item, { children: [/* @__PURE__ */ m(V.Separator, { ...l[0]?.separatorProps }), /* @__PURE__ */ m(F, {
					items: l,
					menuProps: n
				})] }),
				u.map((t, n) => {
					let r = e.length - o + n, i = r === e.length - 1, a = t.current ?? i;
					return /* @__PURE__ */ h(V.Item, {
						...t.itemProps,
						children: [r > 0 && /* @__PURE__ */ m(V.Separator, { ...t.separatorProps }), /* @__PURE__ */ m(j, {
							item: t,
							isCurrent: a
						})]
					}, t.id ?? r);
				})
			]
		})
	});
}
x.displayName = "Breadcrumbs.Root", S.displayName = "Breadcrumbs.List", C.displayName = "Breadcrumbs.Item", w.displayName = "Breadcrumbs.Link", T.displayName = "Breadcrumbs.MenuLink", E.displayName = "Breadcrumbs.MenuText", D.displayName = "Breadcrumbs.MenuTrigger", O.displayName = "Breadcrumbs.Text", k.displayName = "Breadcrumbs.Icon", A.displayName = "Breadcrumbs.Separator";
function B({ items: e, listProps: t, menuProps: n, currentBadgeLabel: r, navigationPathTitle: s, visibleEdgeItemsCount: c = v, visibleItemsCount: l = _, ...u }) {
	let { t: d } = i(), f = r ?? d("public_pages_purchase.breadcrumbs.current", { defaultValue: "Current" }), p = s ?? d("public_pages_purchase.breadcrumbs.navigation_path", { defaultValue: "Navigation path" });
	return o(a.isMobile, { initializeWithValue: !1 }) ? /* @__PURE__ */ m(R, {
		items: e,
		menuProps: n,
		currentBadgeLabel: f,
		navigationPathTitle: p,
		...u
	}) : /* @__PURE__ */ m(z, {
		items: e,
		listProps: t,
		menuProps: n,
		visibleEdgeItemsCount: c,
		visibleItemsCount: l,
		...u
	});
}
var V = Object.assign(B, {
	Root: x,
	List: S,
	Item: C,
	Link: w,
	MenuLink: T,
	MenuText: E,
	MenuTrigger: D,
	Text: O,
	Icon: k,
	Separator: A
});
//#endregion
export { V as Breadcrumbs };
